import { useCallback, useMemo, useState } from "react";

const DEPARTMENT_CRUMB = { label: "Departments", href: "/v2/departments" };

const buildItems = ({ pageLabel, pageHref, subLabel, subHref, tabLabel, tabHref }) => {
  const items = [DEPARTMENT_CRUMB];

  if (pageLabel) {
    items.push({
      label: pageLabel,
      ...(pageHref ? { href: pageHref } : {}),
    });
  }

  if (subLabel) {
    items.push({
      label: subLabel,
      ...(subHref ? { href: subHref } : {}),
    });
  }

  if (tabLabel) {
    items.push({
      label: tabLabel,
      ...(tabHref ? { href: tabHref } : {}),
    });
  }

  return items;
};

export const useDepartmentsBreadcrumbs = () => {
  const [items, setItems] = useState([DEPARTMENT_CRUMB]);

  const addItem = useCallback((item) => {
    if (!item || !item.label) return;

    setItems((prev) => [...prev, item]);
  }, []);

  const removeLastItem = useCallback(() => {
    setItems((prev) => (prev.length > 1 ? prev.slice(0, -1) : prev));
  }, []);

  const clear = useCallback(() => {
    setItems([DEPARTMENT_CRUMB]);
  }, []);

  const setPageBreadcrumb = useCallback((pageLabel, subLabel, options = {}) => {
    const { pageHref, subHref, tabLabel, tabHref } = options;
    setItems(buildItems({ pageLabel, pageHref, subLabel, subHref, tabLabel, tabHref }));
  }, []);

  const helpers = useMemo(
    () => ({
      setItems,
      addItem,
      removeLastItem,
      clear,
      setPageBreadcrumb,
    }),
    [addItem, removeLastItem, clear, setPageBreadcrumb]
  );

  return { items, helpers };
};

